import { useLogError } from '@/src/common/hooks/useLogError'
import { useAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import type { UseCompletePlaidLink } from '@/src/common/hooks/usePlaidLink/useCompletePlaidLink/CompletePlaidLinkMutation'
import { VirtualCardApi } from '@/src/experiences/virtual-card/store'

export const useCompletePlaidLink: UseCompletePlaidLink<
  (typeof VirtualCardApi.endpoints)['GET /card/:cardAccountId/payments/methods']['Types']['QueryArg']['params']
> = ({ cardAccountId }) => {
  const Alert = useAlert(useCompletePlaidLink.name)
  const logError = useLogError()
  const [completePlaidLink, { isLoading }] =
    VirtualCardApi.endpoints['PUT /card/:cardAccountId/payments/methods'].useMutation()

  return [
    async ({ publicToken, metadata }, ...context) => {
      try {
        await completePlaidLink({
          params: { cardAccountId },
          body: { type: 'account', publicToken },
        })
      } catch (error) {
        logError('plaid linking on new platform-based arch failed', error, ...context)

        Alert.alert(
          `The account(s) ${metadata.institution?.name ? `from ${metadata.institution.name} ` : ''}could not be linked`,
          'Please try again later or with a different account',
        )
      }
    },
    { loading: isLoading },
  ]
}
